import { useQuery } from '@tanstack/react-query';
import { ExtractFnReturnType } from '@/lib/react-query';
import { TypesConsolidationData } from '@/types/ConsolidationData.ts';
import getApi from '@/lib/axios';

async function getOcupacaoTurmas(): Promise<any> {
  const api = await getApi();

  const { data } = await api.get('/raiox/turmas/ocupacao/');
  return data;
}


type QueryFnType = typeof getOcupacaoTurmas;

function useOcupacaoTurmasRank() {
  return useQuery<ExtractFnReturnType<QueryFnType>>({
    queryKey: ['fetch-ocupacao-turmas'],
    queryFn: () => getOcupacaoTurmas(),
  });
}

export { useOcupacaoTurmasRank };
